import Vue from 'vue'
import VueI18n from "vue-i18n"
import en from "./lang/en_US"
import th from "./lang/th_TH"
import store from '../store'

Vue.use(VueI18n)
// Create VueI18n instance with options
const i18n = new VueI18n({
    //construction a new VueI18n
    locale: store.state.General.lang,
    fallbackLocale: "en", //always displays English if Thai translation is not available
    messages: {
        //'locales' directory contains all the translations in the form of json files
        en,
        th
    }
})

export default i18n
